export default __webpack_public_path__ + "95c691c16ead5979adc4b06d58aca408.svg";